import { graphql, StaticQuery, useStaticQuery } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import { DraftboxWebsiteMetaFull } from "../../models/draftbox-websitemeta.model";
import FacebookImageMeta from "./FacebookMeta";

const WebsiteMeta = () => {
  const data: DraftboxWebsiteMetaFull = useStaticQuery(graphql`
    query MyQuery {
      draftboxSettings {
        ...DraftboxWebsiteMetadataFull
      }
    }
  `);

  const {
    draftboxSettings: {
      seo: { facebook, meta, twitter, webmaster },
      identity,
    },
  } = data;
  const jsonLd = {
    "@context": `https://schema.org/`,
    "@type": "WebSite",
    url: identity.siteUrl,
    image: identity.coverUrl
      ? {
          "@type": `ImageObject`,
          // url: url.resolve(identity.siteUrl, identity.coverUrl.publicURL),
          url: new URL(identity.coverUrl.publicURL, identity.siteUrl).href,
        }
      : undefined,
    publisher: {
      "@type": `Organization`,
      name: identity.siteName,
      logo: identity.logoUrl
        ? {
            "@type": `ImageObject`,
            // url: url.resolve(identity.siteUrl, identity.logoUrl.publicURL),
            url: new URL(identity.logoUrl.publicURL, identity.siteUrl).href,
          }
        : undefined,
    },
    mainEntityOfPage: {
      "@type": `WebPage`,
      "@id": identity.siteUrl,
    },
    description: meta.description,
  };

  return (
    <>
      <Helmet htmlAttributes={{ lang: identity.language || "auto" }}>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        {/* TODO add canonical Url once we get siteUrl from identity */}
        <link rel="canonical" href={identity.siteUrl} />

        <meta property="og:site_name" content={identity.siteName} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={facebook.title} />
        <meta property="og:description" content={facebook.description} />
        {/* TODO add canonical Url once we get siteUrl from identity */}
        <meta property="og:url" content={identity.siteUrl} />

        {/*TODO  Add siteUrl prefix for image */}

        <meta name="twitter:title" content={twitter.title} />
        <meta name="twitter:description" content={twitter.description} />

        {/* TODO add canonical Url once we get siteUrl from identity */}
        <meta name="twitter:url" content={identity.siteUrl} />

        {twitter.handle && (
          <meta name="twitter:site" content={twitter.handle} />
        )}
        {twitter.handle && (
          <meta name="twitter:creator" content={twitter.handle} />
        )}

        {/* TODO Fix image url by adding siteUrl prefix */}

        {twitter.imageUrl && (
          <meta
            name="twitter:image"
            // content={url.resolve(
            //   identity.siteUrl,
            //   twitter.imageUrl.seo?.fixed?.src
            //     ? twitter.imageUrl.seo?.fixed?.src
            //     : twitter.imageUrl.publicURL
            // )}
            content={
              new URL(
                twitter.imageUrl.seo?.fixed?.src
                  ? twitter.imageUrl.seo?.fixed?.src
                  : twitter.imageUrl.publicURL,
                identity.siteUrl
              ).href
            }
          />
        )}

        {twitter.imageUrl && (
          <meta name="twitter:card" content="summary_large_image" />
        )}

        <script type="application/ld+json">
          {JSON.stringify(jsonLd, undefined, 4)}
        </script>

        {webmaster.baiduVerificationCode && (
          <meta
            name="baidu-site-verification"
            content={webmaster.baiduVerificationCode}
          />
        )}
        {webmaster.googleVerificationCode && (
          <meta
            name="google-site-verification"
            content={webmaster.googleVerificationCode}
          />
        )}
        {webmaster.pinterestVerificationCode && (
          <meta
            name="p:domain_verify"
            content={webmaster.pinterestVerificationCode}
          />
        )}
        {webmaster.yandexVerificationCode && (
          <meta
            name="yandex-verification"
            content={webmaster.yandexVerificationCode}
          />
        )}
        {webmaster.bingVerificationCode && (
          <meta name="msvalidate.01" content={webmaster.bingVerificationCode} />
        )}
      </Helmet>

      {/* TODO Fix image url by adding siteUrl prefix */}
      {facebook.imageUrl && (
        <FacebookImageMeta
          // imageUrl={url.resolve(
          //   identity.siteUrl,
          //   facebook.imageUrl?.seo?.fixed?.src
          //     ? facebook.imageUrl?.seo?.fixed?.src
          //     : facebook.imageUrl.publicURL
          // )}
          imageUrl={
            new URL(
              facebook.imageUrl?.seo?.fixed?.src
                ? facebook.imageUrl?.seo?.fixed?.src
                : facebook.imageUrl.publicURL,
              identity.siteUrl
            ).href
          }
          imageHeight={
            facebook.imageUrl?.seo?.fixed
              ? facebook.imageUrl.seo.fixed.height.toString()
              : null
          }
          imageWidth={
            facebook.imageUrl?.seo?.fixed
              ? facebook.imageUrl.seo.fixed.width.toString()
              : null
          }
          appId={facebook.appId}
        />
      )}
    </>
  );
};

export default WebsiteMeta;
